import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFileBookmark = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.686 3.676a.52.52 0 0 1 .382-.176h1.229v9.212a.75.75 0 0 0 1.3.51l2.086-2.253 2.086 2.252a.75.75 0 0 0 1.3-.51V3.5h.24L18.5 8.025v11.802a.73.73 0 0 1-.186.496.52.52 0 0 1-.382.177H6.068a.52.52 0 0 1-.382-.177.73.73 0 0 1-.186-.496V4.173c0-.196.073-.374.186-.497M12.57 3.5H8.797v7.298l1.336-1.442a.75.75 0 0 1 1.1 0l1.336 1.442zm.75-1.5h1.317a.75.75 0 0 1 .55.24L19.8 7.221c.129.139.2.32.2.51v12.096c0 .558-.205 1.105-.586 1.516a2.02 2.02 0 0 1-1.482.657H6.068c-.568 0-1.1-.244-1.482-.657A2.23 2.23 0 0 1 4 19.827V4.173c0-.559.205-1.105.586-1.516A2.02 2.02 0 0 1 6.068 2h7.251"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgFileBookmark;
